import { t } from 'i18next';
import * as yup from 'yup';

export const switchUsersSchema = () =>
  yup.object().shape({
    user: yup
      .object()
      .shape({
        id: yup.string().required(),
        email: yup.string().nullable(),
        firstName: yup.string().nullable(),
        lastName: yup.string().nullable(),
        status: yup.string().nullable(),
      })
      .nullable()
      .required(t('errorUserRequired')),
  });
